import {NgModule} from '@angular/core';
import {SpConfigPage} from './page/config/sp-config/sp-config.page';
import {SpDashboardPage} from './page/dashboard/sp-dashboard/sp-dashboard.page';
import {SpMyBoardPage} from './page/dashboard/sp-my-board/sp-my-board.page';
import {SpProjectObjectPage} from './page/object/sp-project-object-page/sp-project-object.page';
import {SpBoardTemplateObjectPage} from './page/object/sp-board-template-object-page/sp-board-template-object.page';
import {SpBoardObjectPage} from './page/object/sp-board-object-page/sp-board-object.page';
import {SpSprintObjectPage} from './page/object/sp-sprint-object-page/sp-sprint-object.page';
import {
    SpProjectObjectComponent
} from './component/protected-components/sp-project-object-component/sp-project-object.component';
import {
    SpBoardTemplateObjectComponent
} from './component/protected-components/sp-board-template-object-component/sp-board-template-object.component';
import {
    SpBoardObjectComponent
} from './component/protected-components/sp-board-object-component/sp-board-object.component';
import {
    SpSprintObjectComponent
} from './component/protected-components/sp-sprint-object-component/sp-sprint-object.component';
import {SpKanbanBoardComponent} from './component/protected-components/sp-kanban-board/sp-kanban-board.component';
import {SP_ENTITY_PROVIDER} from './sp.entity-provider';
import {CoreModule} from '../../core/core.module';
import {FeaturePlanningRoutingModule} from '../feature-planning.routing.module';
import {PMessagesComponent} from '../../core/shared/p-messages/p-messages.component';
import {ConfirmDialogModule} from 'primeng/confirmdialog';

@NgModule({
    declarations: [
        SpConfigPage,
        SpDashboardPage,
        SpMyBoardPage,
        SpProjectObjectPage,
        SpBoardTemplateObjectPage,
        SpBoardObjectPage,
        SpSprintObjectPage,
        SpProjectObjectComponent,
        SpBoardTemplateObjectComponent,
        SpBoardObjectComponent,
        SpSprintObjectComponent,
        SpKanbanBoardComponent,
    ],
    exports: [
        SpProjectObjectComponent,
        SpBoardTemplateObjectComponent,
        SpBoardObjectComponent,
        SpSprintObjectComponent,
        SpKanbanBoardComponent,
    ],
    imports: [
        CoreModule,
        FeaturePlanningRoutingModule,
        PMessagesComponent,
        ConfirmDialogModule
    ],
    providers: [
        SP_ENTITY_PROVIDER,
    ]
})
export class SpModule {
}
